import axios from "axios";

export const fetchSet = async wardId => {
    try {
        const result = await axios.get(`/app/request/duty-roster/set/${wardId}`);
        return result;
    } catch (error) {
        console.error(error);
    }
};

export const fetchYear = async wardId => {
    try {
        const result = await axios.get(`/app/general/year?wardId=${wardId}`);
        return result;
    } catch (error) {
        console.error(error);
    }
};
